import React from 'react';
import { List } from 'semantic-ui-react';

interface Props {
    etiqueta: React.ReactNode;
    valor: React.ReactNode;
    color?: string;
    /** Por defecto List.Item. */
    componentePadre?: React.ComponentType;
}

export const ItemConEtiqueta: React.FunctionComponent<Props> = props => {
    const { etiqueta, valor, color, componentePadre = List.Item, ...resto } = props;
    const Componente = componentePadre;
    return (
        <Componente {...resto}>
            {etiqueta}:{' '}
            <span style={{ color }}>
                <b>{valor}</b>
            </span>
        </Componente>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/componentes/ItemConEtiqueta.tsx